import React, { useState } from "react";

function AtticCleanoutFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How much does an attic cleanout cost?",
      content: `
The cost is based on amount of space the items take up on the truck. Contact us for a free quote with transparent pricing and no hidden fees.
      `,
    },
    {
      title: "What areas do you serve?",
      content: `
       We proudly provide attic cleanout services in the following locations:

Campbell, Los Altos, Fremont, Palo Alto, Saratoga, East Palo Alto, Cupertino, Los Gatos, Mountain View, San Jose, Milpitas, Newark, Santa Clara, and Sunnyvale.
      `,
    },
    {
      title: "How do I schedule an attic cleanup?",
      content: `
       Hassle-Free Attic Cleanout! Give us a call to schedule your attic cleanout. Provide your full name, address, preferred date and time, and details on the items you need removed. Our team will handle all the heavy lifting, leaving your attic clean and clutter-free!
      `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default AtticCleanoutFAQs;
